import { render, staticRenderFns } from "./DestinatariosModalComponent.vue?vue&type=template&id=13984ed1&scoped=true"
import script from "./DestinatariosModalComponent.vue?vue&type=script&lang=js"
export * from "./DestinatariosModalComponent.vue?vue&type=script&lang=js"
import style0 from "./DestinatariosModalComponent.vue?vue&type=style&index=0&id=13984ed1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13984ed1",
  null
  
)

export default component.exports